import { useCallback } from 'react'

import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'
import { Tooltip } from 'govwell-ui'

type Props = {
  errorMessage?: string
  hasUnsavedChanges: boolean
  isLoading: boolean
  onSave: () => Promise<unknown>
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
}

const SaveChangesButton = ({
  errorMessage,
  hasUnsavedChanges,
  isLoading,
  onSave,
  setIsLoading,
}: Props) => {
  const onOk = useCallback(async () => {
    try {
      setIsLoading(true)
      await onSave()
    } catch {
      return Promise.reject()
    } finally {
      setIsLoading(false)
    }
  }, [onSave, setIsLoading])

  const disabled = !hasUnsavedChanges || !!errorMessage

  return (
    <Tooltip content={errorMessage ? errorMessage : disabled ? 'There are no changes to save' : ''}>
      <Button
        type="primary"
        disabled={disabled}
        loading={isLoading}
        onClick={onOk}
        icon={<FontAwesomeIcon icon={faCheck} />}
      >
        Save
      </Button>
    </Tooltip>
  )
}

export default React.memo(SaveChangesButton)
